export default "__VITE_ASSET__348ea485__"